import React from 'react';
import { motion } from 'framer-motion';
import { Check, Flower2, X } from 'lucide-react';
const notThis = ['This is not a collection of random meditations copied from the internet.', 'This is not a theoretical book you have to rewrite before it works in a real class.', 'This is not content designed for a different type of teacher that you have to completely adapt.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-cream relative overflow-hidden" data-id="element-231" data-mp="z25zkxhdlhqq">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gold/60" data-id="element-232" data-mp="u2tae6317ykz" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-233" data-mp="182kn83htb8xe">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-234" data-mp="17zydbx7g8hc0">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-brand-soft border border-brand/25 text-brand-dark mb-5" data-id="element-235" data-mp="2ffmnf8d95d7v">
            <Flower2 size={26} aria-hidden="true" data-id="element-236" data-mp="2buxhlcnwsrbz" />
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-extrabold mb-4 text-ink" data-id="element-237" data-mp="2guademwrd8qp">
            The most complete mindfulness and meditation teaching library for teachers worldwide
          </h2>
          <h3 className="text-xl font-bold text-brand mb-3" data-id="element-238" data-mp="2pw04frmqa5ny">
            Mindfulness &amp; Meditation Teacher Ready
          </h3>
          <p className="text-base md:text-lg text-graphite mb-10" data-id="element-239" data-mp="1t6itoy8w1tfe">
            6 complete systems in 1 · 150+ sessions ready to teach · 5 strategic bonuses ·
            Everything ready to use today
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-240" data-mp="2242s7zfd9bmb">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-paper p-6 rounded-2xl border border-silver-light" data-id="element-241" data-mp="26xe0m4ztu0gc">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-242" data-mp="2cse4vj2gqtrx">
                <X className="text-silver shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-243" data-mp="2cq1lr2kyydda" />
                <p className="text-graphite-light text-sm" data-id="element-244" data-mp="2qir8584etkax">{item}</p>
              </div>)}
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-brand-soft p-6 rounded-2xl border border-brand/30" data-id="element-245" data-mp="1ysd19vutd88r">
            <div className="flex items-start gap-3" data-id="element-246" data-mp="22u80mut6pbjw">
              <Check className="text-brand-dark shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-247" data-mp="22seurhqeavcy" />
              <p className="text-ink font-medium text-base leading-relaxed" data-id="element-248" data-mp="3j6n2w7af5252">
                This is a complete professional teaching system, so you walk into every session
                completely prepared, confident, and ready to guide a practice your students will
                actually feel and remember.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}